import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-snackbar',
  templateUrl: './print-snackbar.component.html',
  styleUrls: ['./print-snackbar.component.scss']
})
export class PrintSnackbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
